import React from 'react';
import CustomTable from '../../components/Table/CustomTable';
import { CardHeader, CardContent, Typography } from '@material-ui/core';
import DropDownMenu from '../../components/DropDownMenu/DropDownMenu';
import { useSelector } from 'react-redux';
import { ExportToExcel } from '../ExportData/ExportDataToExcel';

const ResultTable = () => {
  const resultsCols = useSelector(state => state.customQueryBody.columns) || [];
  const tableHeadCols = useSelector(state => state.customQueryBody.tableColumns);
  const results = useSelector(state => state.customQueryHeader.relationTableData) || [];
  let {
    totalCount
  } = results;
  const exportApi = useSelector(state => state.customQueryHeader.relationUrl);
  const requestBody = useSelector(state => state.customQueryHeader.relRequestBody);
  const loader = useSelector(state => state.customQueryHeader.isLoader);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "tbl-crd-hdr",
    action: /*#__PURE__*/React.createElement(DropDownMenu, {
      menuItems: resultsCols
    }) // render dropdown menu
    ,
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      component: "span"
    }, "Results"), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      component: "span",
      className: "download-icon"
    }, /*#__PURE__*/React.createElement(ExportToExcel, {
      apiUrl: exportApi,
      dataResults: results.data,
      apiRequestBody: requestBody,
      totalCount: totalCount,
      fileName: "results",
      loader: loader
    })), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      component: "span",
      className: "total-count-span"
    }, `Showing ${totalCount} records`))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(CustomTable, {
    columns: tableHeadCols,
    results: results
  })));
};

export default /*#__PURE__*/React.memo(ResultTable);